export default __webpack_public_path__ + "8da6d98b7ed07fa5509c8308d5774df8.png";